// extracted by mini-css-extract-plugin
export default {"timer":"bZ-z","loaded":"cZ-z"};